import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../services/firebase";
import { doc, getDoc } from "firebase/firestore";
import PaymentBox from "../components/payments/PaymentBox";
import { toCents } from "../lib/payments";
import { sha256 } from "../lib/tokens";

function money(n){ try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(n||0);}catch{return `$${Number(n||0).toFixed(2)}`;} }

export default function ManageBooking(){
  const { token } = useParams(); // format: reservationId.tokenString
  const [reservation, setReservation] = useState(null);
  const [ok, setOk] = useState(false);

  useEffect(()=> {
    (async ()=>{
      if (!token || !token.includes('.')) return;
      const [rid, raw] = token.split('.');
      const snap = await getDoc(doc(db,'reservations', rid));
      if (!snap.exists()) return;
      const r = snap.data();
      const hash = await sha256(raw);
      if (hash === r.manageTokenHash) { setOk(true); setReservation({ id: rid, ...r }); }
    })();
  }, [token]);

  const balance = useMemo(()=>{
    const paid = Number(reservation?.payment?.amountCharged || 0);
    const total = Number(reservation?.payment?.total || 0);
    return Math.max(0, total - paid);
  }, [reservation]);

  if (!reservation) return <div className="container"><p>Loading…</p></div>;
  if (!ok) return <div className="container"><p>Invalid link.</p></div>;

  return (
    <div className="container" style={{padding:'24px 0'}}>
      <h1>Manage Booking</h1>
      <p><strong>Reservation:</strong> {reservation.id}</p>
      <p><strong>Item:</strong> {reservation.productTitle || reservation.productId}</p>
      <p><strong>Dates:</strong> {reservation.startDate} → {reservation.endDate}</p>
      <p><strong>Paid:</strong> {money(reservation.payment?.amountCharged)} &nbsp; <strong>Total:</strong> {money(reservation.payment?.total)}</p>

      {balance > 0 ? (
        <>
          <h3>Pay Remaining Balance ({money(balance)})</h3>
          <PaymentBox
            amountCents={toCents(balance)}
            email={reservation?.contact?.email}
            metadata={{ reservationId: reservation.id, reason: "balance" }}
            onPaid={async () => {
              // You may want to update reservation doc to reflect fully paid.
              alert("Thanks! Balance paid.");
              window.location.reload();
            }}
          />
        </>
      ) : <p><strong>Balance: {money(0)}</strong> — You're all set!</p>}

      <hr/>
      <h3>Need to reschedule or cancel?</h3>
      <p>Email us and include this link. We'll take care of it.</p>
    </div>
  );
}
